
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.126 14.56a8.136 8.136 0 111.434-1.434l5.44 5.42-1.444 1.444-5.42-5.43h-.01zm-4.983-.326a6.1 6.1 0 006.101-6.101 6.1 6.1 0 00-6.101-6.101 6.1 6.1 0 00-6.101 6.101 6.1 6.1 0 006.101 6.101z"}}),_c('path',{attrs:{"d":"M11.511 5.885L9.263 8.133l2.248 2.248-1.12 1.119-2.248-2.247L5.895 11.5l-1.12-1.119 2.248-2.248-2.248-2.248 1.12-1.12 2.248 2.248 2.248-2.248 1.12 1.12z"}})])
          )
        }
      }
    